import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/reset-password_/$nonceToken')({
  staticData: { team: 'users-infra' },
});
